<template>
    <div class="d-flex justify-content-end align-items-center px-2 py-2 bg-white border-bottom" @click.stop>
        <button type="button" class="btn btn-sm me-2 d-inline-flex align-items-center justify-content-center"
            :class="crosshairOn ? 'btn-primary' : 'btn-outline-secondary'" @click.stop="$emit('toggle-crosshair')"
            title="Crosshair" aria-label="Crosshair">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                <path d="M12 2v6M12 16v6M2 12h6M16 12h6" stroke="currentColor" stroke-width="2.6"
                    stroke-linecap="round" />
                <rect x="10.5" y="10.5" width="3" height="3" fill="currentColor" />
            </svg>
        </button>
        <button type="button" class="btn btn-sm me-3 d-inline-flex align-items-center justify-content-center"
            :class="infoOn ? 'btn-primary' : 'btn-outline-secondary'" @click.stop="$emit('toggle-info')" title="Info"
            aria-label="Info">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                <path d="M7 3h7l3 3v15H7V3z" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                <path d="M14 3v4h4" stroke="currentColor" stroke-width="2" stroke-linejoin="round" />
                <path d="M9 11h6M9 14h6M9 17h4" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <circle cx="18.5" cy="8" r="4" fill="currentColor" />
                <path d="M18.5 10.2V7.7" stroke="#fff" stroke-width="2" stroke-linecap="round" />
                <circle cx="18.5" cy="6.2" r="1.1" fill="#fff" />
            </svg>
        </button>
        <button ref="btnTf" type="button" class="btn btn-sm btn-outline-primary dropdown-toggle me-2"
            @click.stop="emitOpen('tf')">
            {{ tfLabel }}
        </button>
        <button ref="btnType" type="button" class="btn btn-sm btn-outline-primary dropdown-toggle me-2"
            @click.stop="emitOpen('type')">
            {{ chartTypeLabel }}
        </button>
        <button ref="btnStudies" type="button" class="btn btn-sm btn-outline-primary dropdown-toggle"
            @click.stop="emitOpen('studies')">
            Studies
        </button>
        <button type="button" class="btn btn-sm me-2 d-inline-flex align-items-center justify-content-center"
            :class="drawOn ? 'btn-primary' : 'btn-outline-secondary'" @click.stop="$emit('toggle-draw')" title="Draw"
            aria-label="Draw">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                <path d="M4 20h4l11-11a2 2 0 0 0 0-3l-1-1a2 2 0 0 0-3 0L4 16v4z" stroke="currentColor" stroke-width="2"
                    stroke-linejoin="round" />
                <path d="M13 6l5 5" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            </svg>
        </button>
        <button type="button" class="btn btn-sm me-2 d-inline-flex align-items-center justify-content-center"
            :class="tableOn ? 'btn-primary' : 'btn-outline-secondary'" @click.stop="$emit('toggle-table')"
            title="Table View" aria-label="Table">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                <rect x="3" y="5" width="18" height="14" rx="1.5" stroke="currentColor" stroke-width="3" />
                <path d="M3 10h18M3 14h18M8 5v14M16 5v14" stroke="currentColor" stroke-width="3" />
            </svg>
        </button>
        <button v-if="!isPopout" type="button"
            class="btn btn-sm btn-outline-secondary mr-2 d-inline-flex align-items-center justify-content-center"
            @click.stop="$emit('popout')" title="Popout" aria-label="Popout">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" aria-hidden="true">
                <path d="M14 3h7v7" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M21 3l-9 9" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
                <path d="M10 5H5a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" stroke="currentColor"
                    stroke-width="2" stroke-linecap="round" />
            </svg>
        </button>
    </div>
</template>
<script>
export default {
    name: "CandlesToolbar",
    props: {
        crosshairOn: { type: Boolean, default: false },
        infoOn: { type: Boolean, default: false },
        tfLabel: { type: String, default: "1D" },
        chartTypeLabel: { type: String, default: "Candles" },
        tableOn: { type: Boolean, default: false },
        drawOn: { type: Boolean, default: false },
    },
    emits: ["toggle-crosshair", "toggle-info", "open-menu", "popout", "toggle-table", "toggle-draw",],
    computed: {
        isPopout() {
            const q = this.$route?.query || {};
            return Object.prototype.hasOwnProperty.call(q, "popout");
        },
    },
    methods: {
        emitOpen(kind) {
            const anchorEl =
                kind === "tf"
                    ? this.$refs.btnTf
                    : kind === "type"
                        ? this.$refs.btnType
                        : this.$refs.btnStudies;
            this.$emit("open-menu", { kind, anchorEl });
        },
    },
};
</script>
